import { useState } from "react";
import { adminLinks, ownerLinks } from "./navigationLinks";
import { useAccessControls } from "@/hooks/useAccessControls";
import { useMenuVisibility } from "@/hooks/useMenuVisibility";
import { useFilteredLinks } from "@/hooks/sidebar/useFilteredLinks";
import { useFeatureVisibility } from "@/hooks/sidebar/useFeatureVisibility";
import { useAccessCodesState } from "@/hooks/sidebar/useAccessCodesState";

export const useSidebarState = (userType: "admin" | "owner") => {
  const links = userType === "admin" ? adminLinks : ownerLinks;
  const { accessControls, refetch } = useAccessControls(userType);
  
  const { authorizedFeatures, accessCodes } = useAccessCodesState(accessControls);
  
  const {
    visibleMenuItems,
    selectedMenuItem,
    isDialogOpen,
    setIsDialogOpen,
    setSelectedMenuItem,
    toggleMenuItemVisibility,
  } = useMenuVisibility(accessControls, links, refetch);

  const filteredLinks = useFilteredLinks(userType, links);

  const {
    isFeatureDisabled,
    shouldShowEyeIcon,
    isFeatureVisible,
  } = useFeatureVisibility(authorizedFeatures, accessCodes, visibleMenuItems);

  const handleEyeClick = (name: string, feature?: string) => {
    if (feature && accessCodes[feature] && !isFeatureDisabled(feature)) {
      setSelectedMenuItem(name);
      setIsDialogOpen(true);
    } else {
      toggleMenuItemVisibility(name);
    }
  };

  return {
    authorizedFeatures,
    visibleMenuItems,
    accessCodes,
    selectedMenuItem,
    isDialogOpen,
    filteredLinks,
    setIsDialogOpen,
    setSelectedMenuItem,
    handleEyeClick,
    toggleMenuItemVisibility,
    shouldShowEyeIcon,
    isFeatureVisible,
  };
};